import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const styles = (theme) => ({
    buttonRootStyle: {
        display: "flex",
        fontSize: theme.typography.pxToRem(15),
        fontFamily: "MAN-light, Arial, sans-serif",
        color: "#303C49",
        backgroundColor: "#ffffff",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#303C49",
        borderRadius: 0,
        padding: "10px 15px",
        textAlign: "center",
        verticalAlign: "middle",
        textTransform: "none",
        cursor: "pointer",
        minWidth: "40px",
        lineHeight: 1.428571429,
        "&:hover": {
            backgroundColor: "#e6e6e6",
        },
    },
});

const CTAButton = ({ classes: { buttonRootStyle }, label, href }) => (
    <Button classes={{ root: buttonRootStyle }} component="a" href={href} target="_blank" rel="noopener noreferrer">
        {label}
    </Button>
);

export default withStyles(styles)(CTAButton);



// WEBPACK FOOTER //
// ./src/components/Button.js